// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2394":"423824d5a0088b8d21f1","5151":"c4586d618fed2b01eaca","7512":"423824d5a0088b8d21f1","7587":"423824d5a0088b8d21f1","8736":"2b2623ff7b10666327fe"}[chunkId] + ".css";
};